import { useSnackbarHelper } from '@/components/useSnackbarHelper';
import { getErrorMessage } from '@/utils/stringHelper';
import { Grid2 } from '@mui/material';
import React, { useCallback, useEffect } from 'react';
import { LuckyDrawRewards } from '../../../components/luckyDrawRewards';
import { validationResultingPromotions } from '../../../tools';
import { IPromoProps } from '../../type';
import { renderContent, tabContent } from '../tabContent';

export const LuckyDrawReward: React.FC<IPromoProps> = (props) => {
    const { formik, setCanMoveFunc } = props;
    const { showSnackbar } = useSnackbarHelper();
    // get type from url params
    const { values } = formik;
    const { resultingPromotions = [] } = values;

    const canMove = useCallback(async () => {
        // name is required
        // numberOfDeals is required and greater than 0
        let message = '';
        let canMove = true;
        try {
            validationResultingPromotions(resultingPromotions)
        } catch (e) {
            showSnackbar(getErrorMessage(e), 'error');
            message = getErrorMessage(e);
            canMove = false;
        }
        return {
            message: message,
            canMove: canMove
        };
    }, [values]);

    const wrappedCanMove = useCallback(() => canMove(), [canMove]);
    useEffect(() => {
        setCanMoveFunc(() => wrappedCanMove);
    }, [setCanMoveFunc, wrappedCanMove]);

    const luckyDrawRewardContents: tabContent[] = [
        {
            mdSize: 12,
            node: <LuckyDrawRewards formik={formik} />
        }
    ];

    const render = (): React.ReactNode => {
        return renderContent(luckyDrawRewardContents);
    };
    return (
        <Grid2 sx={{ width: '100%' }} container spacing={1}>
            {render()}
        </Grid2>
    );
};
